<a [href]="url" target="_blank" [style.color]="'var(--ion-color-' + color + ')'">{{ text }}</a>
